import {Value} from "patient-ping-remedy/packages/dropdown-list/lib/DropdownList";
import {ScheduleAppointmentJourneyResponse, TaskStepName} from "@/api/dto/care-journey";
import { colors } from "patient-ping-remedy/packages/theme";
import {ICONS} from "patient-ping-remedy/packages/icon";

export const appointmentTypes: Record<string, string> = {
  pcp: "PCP",
  therapy: "Therapy",
  medication_management: "Medication Management",
  adhd_testing: "ADHD Testing",
  neuropsychology_testing: "Neuropsychology Testing",
  spravato_tms: "Spravato/TMS"
};

export const appointmentTypeOptions: Value[] = Object.keys(appointmentTypes)
  .map(key => ({value: key, label: appointmentTypes[key]}));

export const TERMINAL_APPOINTMENT_STATUSES = new Set<string>([
  'completed',
  'closed',
  'cancelled',
]);

export const getAppointmentStatus = (appointment: ScheduleAppointmentJourneyResponse) => {
  const attendedText = appointment.steps
    .some(step => step.stepName === TaskStepName.APPOINTMENT_CONFIRMATION && step.status === 'completed')
    ? 'Attended' : 'Not attended';
  if(appointment.status === 'completed') {
    return {
      status: 'Completed',
      backgroundColor: colors.green1,
      icon: ICONS.check,
      iconColor: colors.green5,
      progressStatus: 'Completed - ' + attendedText
    };
  }

  if(appointment.status === 'closed' || appointment.status === 'cancelled') {
    return {
      status: 'Closed',
      backgroundColor: colors.green1,
      icon: ICONS.check,
      iconColor: colors.green5,
      progressStatus: 'Closed - ' + attendedText
    };
  }

  if(appointment.orchestrationEngineDetails?.actor != 'AI') {
    return {
      status: 'Needs review',
      backgroundColor: colors.yellow1,
      icon: ICONS["exclamation-triangle"],
      iconColor: colors.yellow5,
      progressStatus: 'Needs review'
    };
  }

  return {
    status: 'In progress',
    backgroundColor: colors.teal1,
    icon: ICONS.clock,
    iconColor: colors.teal5,
    progressStatus: 'In progress',
  };
};
